export default {
  name: 'marking--rePrintByXlsx',
  urlParamName: 'marking--rePrintByXlsx',
};